import React from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { Grid, IconButton, Tooltip } from '@material-ui/core'
import { Monitor, Tablet, Cellphone } from 'mdi-material-ui'
import { handleFormViewSelect } from 'actions/signupForm/addOrEdit'
import language from 'utils/vast-languagepack'

export default connect(
	(state) => ({
		formViewSelected: state.signupForm.addOrEdit.formViewSelected,
		formTypeSelected: state.signupForm.addOrEdit.formTypeSelected,
	}),
	(dispatch) => bindActionCreators({ handleFormViewSelect }, dispatch),
)(({ formViewSelected, handleFormViewSelect, formTypeSelected }) =>
	formTypeSelected === 'custom' ? null : (
		<Grid justify="center" container>
			<Grid item>
				<Tooltip title={language.signupform.add.toolTips.desktopView}>
					<IconButton
						aria-label="Desktop view"
						color={formViewSelected === 'desktop' ? 'secondary' : 'default'}
						onClick={() => handleFormViewSelect('desktop')}
					>
						<Monitor />
					</IconButton>
				</Tooltip>
			</Grid>
			<Grid item>
				<Tooltip title={language.signupform.add.toolTips.tabletView}>
					<IconButton
						aria-label="Tablet view"
						color={formViewSelected === 'tablet' ? 'secondary' : 'default'}
						onClick={() => handleFormViewSelect('tablet')}
					>
						<Tablet />
					</IconButton>
				</Tooltip>
			</Grid>
			<Grid item>
				<Tooltip title={language.signupform.add.toolTips.phoneView}>
					<IconButton
						aria-label="Phone view"
						color={formViewSelected === 'phone' ? 'secondary' : 'default'}
						onClick={() => handleFormViewSelect('phone')}
					>
						<Cellphone />
					</IconButton>
				</Tooltip>
			</Grid>
		</Grid>
	),
)
